module.exports = __webpack_public_path__ + "img/PhoneImg.2ecb3ac0.png";